/// <amd-module name="Wiki/HeaderMetaData/HeaderMetaDataService" />

import { Services, VssService } from "VSS/Platform/Context";

import { HeaderMetaDataActionCreator } from "Wiki/HeaderMetaData/HeaderMetaDataActionCreator";
import { HeaderMetaDataActions, HeaderMetaDataStore, registerActionsWithStores } from "Wiki/HeaderMetaData/HeaderMetaDataStore";
import { IHeaderMetaDataFlux, IHeaderMetaDataService } from "Wiki/HeaderMetaData/Interfaces/IHeaderMetaDataService";
import { ActionListener } from "Wiki/ViewCommon/ActionListener";

export class HeaderMetaDataService extends VssService implements IHeaderMetaDataService {
    public setupFlux(): IHeaderMetaDataFlux {
        const actionListener = new ActionListener();
        const pageMetaDataActions = new HeaderMetaDataActions();
        const store = new HeaderMetaDataStore();
        registerActionsWithStores(actionListener, pageMetaDataActions, store);
        const actionCreator = new HeaderMetaDataActionCreator(pageMetaDataActions, store, this.pageContext);
        return {
            actionCreator,
            store,
            removeActionListeners: () => actionListener.removeListeners()
        };
    }
}

Services.add("wiki-headermetadata-service", { serviceFactory: HeaderMetaDataService });
